import { jsx as _jsx } from "react/jsx-runtime";
import { ConfirmationModal } from "@air/component-confirmation-modal";
import { useToasts } from "@air/provider-toast";
import { reportErrorToBugsnag } from "@air/utils-error";
import noop from "lodash/noop";
import pluralize from "pluralize";
import { useState } from "react";
import { useShowSubscriptionExpiredModal } from "~/hooks/useShowSubscriptionExpiredModal";
import { useCurrentWorkspace } from "~/providers/CurrentWorkspaceProvider";
import { useCreateDuplicateBoardTask } from "./hooks/useCreateDuplicateBoardTask";
export const DuplicateBoardModal = (param)=>{
    let { onClose, boards = [], trackLocation, onDuplicate = noop } = param;
    const [isDuplicating, setIsDuplicating] = useState(false);
    const { showToast } = useToasts();
    const { showingSubscriptionExpiredModal } = useShowSubscriptionExpiredModal({
        onClose
    });
    const { currentWorkspace } = useCurrentWorkspace();
    const { createDuplicateBoardTask } = useCreateDuplicateBoardTask();
    const workspaceId = currentWorkspace === null || currentWorkspace === void 0 ? void 0 : currentWorkspace.id;
    if (showingSubscriptionExpiredModal) {
        return null;
    }
    const duplicate = async ()=>{
        const targetId = boards[0].parentId;
        if (!workspaceId) {
            throw new Error("No workspaceId found");
        }
        try {
            setIsDuplicating(true);
            await createDuplicateBoardTask({
                prefix: "Copy of ",
                sourceBoardIds: boards.map((param)=>{
                    let { id } = param;
                    return id;
                }),
                targetBoardId: targetId !== null && targetId !== void 0 ? targetId : undefined,
                sourceBoardName: boards[0].title,
                trackLocation
            });
            onDuplicate();
            setIsDuplicating(false);
            onClose();
        } catch (error) {
            reportErrorToBugsnag({
                error,
                context: "Failed to duplicate boards",
                metadata: {
                    data: {
                        boards: boards.map((param)=>{
                            let { id } = param;
                            return id;
                        }).join(", "),
                        parentId: boards[0].parentId
                    }
                }
            });
            setIsDuplicating(false);
            showToast("There was an error while trying to duplicate this board. Please try again later.");
        }
    };
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        id: "duplicate-board-modal",
        isOpen: true,
        title: "Duplicate ".concat(pluralize("board", boards.length)),
        ctaPrimaryText: "Duplicate",
        isLoading: isDuplicating,
        isDisabled: isDuplicating,
        onConfirm: duplicate,
        "data-testid": "DUPLICATE_BOARDS_MODAL",
        description: "Duplicating a board will make an exact copy of the board, including its assets, files, and sub-boards.",
        onDismiss: onClose
    });
};
